<template>
  <div>
    <ion-list lines="none">
      <ion-item button @click="bookmark">
        <ion-icon color="primary" slot="start" name="bookmark"></ion-icon>
        <ion-label>Add to Notebook</ion-label>
      </ion-item>
      <!-- <ion-item button @click="share">
        <ion-icon color="primary" slot="start" name="share"></ion-icon>
        <ion-label>Share</ion-label>
      </ion-item> -->
      <ion-item button @click="clear" :disabled="!showClearButton()">
        <ion-icon color="primary" slot="start" name="trash"></ion-icon>
        <ion-label>Remove highlights</ion-label>
      </ion-item>
    </ion-list>
  </div>
</template>
<script>
export default {
  props: {
    docId: String,
    docType: String
  },

  methods: {
    showClearButton() {
      return this.$parent.$refs["annot8"].state.annotations.length > 0;
    },

    share() {
       const url = `https://lawyerly.ph/laws/view/${this.docId}`;
      if(this.$isWeb) {
        window.open(url, '_blank').focus();
      } else {
        window.plugins.socialsharing.share(`${this.$parent.$data.title} | Lawyerly`, null, null, url);
      }
    },
    
    bookmark() {
      this.$root.$emit("header-command", null, { cmd: "add" });
      this.$ionic.dismissPopover();
    },

    clear() {
      this.$ionic.showAlert(
        "All your highlights will be deleted. Are you sure?",
        {
          cssClass: "medium-width-alert",
          header: "Remove Highlights",
          // subHeader: ,
          buttons: [{ text: "Delete", handler: this._clear }, "Cancel"]
        }
      );
      this.$ionic.dismissPopover();
    },

    _clear() {
      this.$parent.$refs["annot8"].eraseAll();
    }
  }
};
</script>
